import { useEffect, useState } from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { Layout } from './components/layout';
import { useAuthStore } from './lib/auth-store';
import { restoreSession } from './lib/api';
import { LoginPage } from './pages/login';
import { RegisterPage } from './pages/register';
import { DashboardPage } from './pages/dashboard';
import { ProductsPage } from './pages/products';
import { CouponsPage } from './pages/coupons';
import { FeedbackPage } from './pages/feedback';
import { VariationTypesPage } from './pages/variation-types';
import { OrdersPage } from './pages/orders';
import { MessagesPage } from './pages/messages';
import { WalletPage } from './pages/wallet';
import { PayoutsPage } from './pages/payouts';
import { ProfilePage } from './pages/profile';

export function App() {
  const token = useAuthStore((s) => s.token);
  const [booting, setBooting] = useState(true);

  useEffect(() => {
    if (token) {
      setBooting(false);
      return;
    }
    restoreSession().finally(() => setBooting(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (booting) {
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route element={<RequireAuth />}>
        <Route element={<Layout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/coupons" element={<CouponsPage />} />
          <Route path="/variation-types" element={<VariationTypesPage />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="/messages" element={<MessagesPage />} />
          <Route path="/wallet" element={<WalletPage />} />
          <Route path="/payouts" element={<PayoutsPage />} />
          <Route path="/profile" element={<ProfilePage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function RequireAuth() {
  const token = useAuthStore((s) => s.token);
  if (!token) return <Navigate to="/login" replace />;
  return <Outlet />;
}
